/**
 * @author PoornaChandu
 */
import React from 'react';
import { connect } from 'react-redux';
import AIScreen from './AIScreen';

const AIGenerator = () => {

  return (
    <AIScreen />
  );
};

const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.getUserProfile,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(AIGenerator);
